import type React from "react";
import { ReactComponent as Svg } from "./assets/add.svg";
import * as styles from "./Icon.module.scss";

type PlusProps = React.SVGProps<SVGSVGElement>;

export const Plus = ({ className, ...props }: PlusProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
